import { useLayoutEffect, useRef, useState } from "react";

import iconMic from "../../../../assets/images/mir-red.svg";
import { Video } from "../../../../components/video-element";

export const Popup = ({ meetingState }) => {
  const containerRef = useRef(null);
  const containerRectRef = useRef({ width: 0, height: 0 });
  const [htmlRendered, setHtmlRendered] = useState(false);

  const calcSurface = (R, col, row, w, h) => {
    // CellRatio, ColumnCount, RowCount, CanvasWidth, CanvasHeight
    if ((R * col) / row > w / h) return h * ((h / row) * col * R);
    return w * (((w / col) * row) / R);
  };

  const res2matrix = (userCount, w, h) => {
    // UserCount, CanvasWidth, CanvasHeight
    let row = 1;
    let col = 1;
    const ratio = 4 / 3; // CellRatio
    for (let i = 1; i <= userCount; i++) {
      if (col * row > i) continue; // If we have un-filled tiles => skip
      if (calcSurface(col + 1, row, w, h) > calcSurface(col, row + 1, w, h)) row += 1;
      else col += 1;
    }

    if ((ratio * col) / row < w / h) return [(ratio * h) / row, h / row]; // Use full height
    return [w / col, w / col / ratio]; // Use full width
  };

  useLayoutEffect(() => {
    containerRectRef.current = containerRef.current.getBoundingClientRect();

    setHtmlRendered(true);
  }, []);

  // const getUsername = (id, username) => {
  //   if (!meetingState.order) return username;
  //
  //   const split = meetingState.order.split(",");
  //   const user = meetingState.users.active[split[id]];
  //
  //   return user ? user.username : username;
  // };

  const getVideos = () => {
    if (!htmlRendered) return;

    const userCount = meetingState.users.active.length;
    const [w, h] = res2matrix(userCount, containerRectRef.current.width, containerRectRef.current.height);

    // const videoWidth = userCount * w;

    return meetingState.users.active.map((activeUserData) => {
      console.log(activeUserData);
      console.info(meetingState.currentUser);
      const left = -1 * activeUserData.xpos;
      const top = activeUserData.idx === 0 ? 0 : -1 * activeUserData.ypos * (w / activeUserData.width); // convert top
      // based on
      // ratio

      return (
        <div
          key={activeUserData.id}
          className="video-container__grid"
          style={{
            width: w,
            height: h,
          }}>
          <Video
            className={`video__grid ${activeUserData.order === 0 && meetingState.currentUser.isVideoMuted?.local ? "hide1" : ""}`}
            autoPlay
            muted
            srcObject={meetingState.currentUser.pid === activeUserData.pid ? meetingState.webcamStream : meetingState.meetingVideoStream}
            style={{
              left: meetingState.currentUser.pid === activeUserData.pid ? 0 : left,
              top: meetingState.currentUser.pid === activeUserData.pid ? 0 : top,
              width: meetingState.users.active.length > 4 ? "200%" : "100%",
            }}
          />
          <label>{activeUserData.meeting_uname}</label>
          <img src={iconMic} className={`btn-32 btn-mic ${activeUserData.isMuted ? "disable" : ""}`} alt="" />
        </div>
      );
    });
  };

  return <div ref={containerRef}>{getVideos()}</div>;
};
